var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("TopNavigation", { attrs: { "top-act": "8" } }),
      _c(
        "div",
        [
          _c("listTopImg", {
            attrs: {
              imgType: _vm.$store.state.webNavigator == "pc" ? "4" : "5"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _c("twoLevelList", {
            attrs: { twolist: _vm.navLsit },
            on: { twoType: _vm.clickType }
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.type == 1 ? _c("aboutPage") : _vm._e(),
          _vm.type == 2
            ? _c("suggestions", { on: { change: _vm.clickType } })
            : _vm._e(),
          _vm.type == 3
            ? _c("mySuggestions", {
                on: {
                  change: _vm.clickType,
                  suggestionsList: _vm.suggestionsList
                }
              })
            : _vm._e(),
          _vm.type == 4
            ? _c("suggestionsList", { attrs: { phone: _vm.phone } })
            : _vm._e()
        ],
        1
      ),
      _c("FooterNavigation")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f10db50c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f10db50c","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/about/about.vue
// module id = 1219
// module chunks = 9